/**
 *
 * Asynchronously loads the component for SmartLock Module
 *
 */

import loadable from "core/components/loadable";

export default loadable(() => import("./index"));
